import $ from 'jquery';
import _ from 'underscore';
import asyncLoader from 'utils/async-loader';
import trackerDatalab from 'utils/tracker-datalab';
import hootbus from 'utils/hootbus';
import ajaxPromise from 'hs-nest/lib/utils/ajax-promise';
import serverTime from 'utils/server-time';
import util from 'utils/util';
import translation from 'utils/translation';
import { loadMaterialSymbols } from '@fp-icons/icon-base';
import { getToken } from 'fe-pg-lib-captcha';
import { ajaxRequest } from 'utils/ajax-promise';
import { resolveAuthMethod, AUTH_OUTCOME } from './auth-method-lookup';

var RECAPTCHA_ACTION_AUTH_METHOD_LOOKUP = 'signin_auth_method_lookup';
var RECAPTCHA_ACTION_SEND_MAGIC_LINK = 'signin_send_magic_link';

var SEND_MAGIC_LINK_URL = '/ajax/auth/send-magic-link';
var PASSWORDLESS_RESEND_COOLDOWN_SECONDS = 60;
var MAGIC_LINK_IP_RATE_LIMITED = 275;
var MAGIC_LINK_EMAIL_RATE_LIMITED = 276;

var login = {
    init: function () {
        loadMaterialSymbols();

        // if this is a popup, make sure it's tall enough.
        if (window.toolbar && !window.toolbar.visible && $(window).outerHeight() < 600) {
            window.resizeTo($(window).outerWidth(), 600);
        }

        // Kinesis tracking
        serverTime.init();
        trackerDatalab.init('body');

        hootbus.on('frontend.logging', function (level, category, message, data) {
            ajaxPromise({
                method: 'POST',
                url: '/ajax/error/frontend-logging',
                data: {
                    level: level,
                    category: category,
                    message: message,
                    additionalData: data
                }
            }, 'qm');
        });

        var urlParams = hs.util.parseQueryString(location.search);
        var $forms = $('._emailPasswordForm, ._signupForm, ._emailSsoForm, ._linkAccountForm, ._confirmationEmailForm, ._googleAuthenticatorForm');
        var $requiredInputs = $('._requiredInput');
        var $emailInput = $('._emailInput');
        var $passwordInput = $('._passwordInput');

        var $loginEmailInput = $("#loginEmailInput");
        var $loginPasswordInput =  $("#loginPasswordInput");
        var $googleInput =  $("#loginGoogleAuthenticatorInput");
        var $ssoInput =  $("#ssoEmailInput");
        var $createEmailInput =  $("#createEmailInput");
        var $createPasswordInput =  $("#createPasswordInput");
        var $newPasswordInput = $('._passwordInputNew');
        var $confirmPasswordInput = $('._passwordInputNewConfirmation');

        var inputsArray = [$loginEmailInput, $loginPasswordInput, $googleInput, $ssoInput, $createEmailInput, $createPasswordInput]

        inputsArray.forEach(input => {
            if(input !== undefined){
                var $inlineErrorContainer = input.siblings('._inlineErrorContainer');
                var $inlineErrorTitle = $inlineErrorContainer.find('._inlineErrorTitle')
                var $inlineErrorMessage = $inlineErrorContainer.find('._inlineErrorMessage')
                var $inputId = input?.selector?.substr(1, input?.selector?.length)

                if($inputId){
                    $inlineErrorTitle.attr('id', `inlineErrorTitle_${$inputId}`)
                    $inlineErrorMessage.attr('id', `inlineErrorMessage_${$inputId}`)
                    input.attr('aria-describedby', `inlineErrorTitle_${$inputId} inlineErrorMessage_${$inputId}`)
                }
            }
        })

        _.each($forms, login.toggleSubmitBtn);

        // form submission
        $('._submit').click(function (e) {
            var $btn = $(this);
            if ($btn.hasClass('green') && login.validateForm(this)) {
                if (login.isIframe() && $(this).hasClass('_ajaxCreateAccount')) {
                    login.ajaxCreateAccount($btn);
                } else {
                    $btn.closest('form').submit();
                }
            }
            e.preventDefault();
        });

        $forms.keypress(function (ev) {
            if (ev.which === 13) {
                var $target = $(ev.target);
                // Allow Enter to activate non-submit buttons (e.g. password visibility toggle).
                if (
                    $target.is("button:not([type='submit'])") ||
                    $target.closest("button:not([type='submit'])").length
                ) {
                    return;
                }

                ev.preventDefault();
                login.handleEmailPasswordFormEnter($(this));
            }
        });

        if ($newPasswordInput.length && $confirmPasswordInput.length) {
            hs.util.checkNewPasswordPolicy($newPasswordInput, $confirmPasswordInput);
        }

        $newPasswordInput.keyup(function (event) {
            // don't check password if user pressed enter or tab
            var resetPasswordForm = $('#resetPasswordForm').length
            if (event.keyCode != 13 && event.keyCode != 9) {
                if (resetPasswordForm) {
                    hs.util.checkNewPasswordPolicy($(this), $confirmPasswordInput);
                } else {
                    hs.util.checkPasswordPolicy($(this));
                }
            }
        });

        $confirmPasswordInput.keyup(function (event) {
            if (event.keyCode != 13 && event.keyCode != 9) {
                    var newPassword = $('._passwordInputNew')
                    hs.util.checkNewPasswordPolicy(newPassword, $(this));
                }
        });

        $requiredInputs.on("keyup blur input", _.debounce(function () {
            var resetPasswordForm = $('#resetPasswordForm').length
            if(resetPasswordForm) {
                login.toggleSubmitResetPasswordButton(this);
            } else {
                login.toggleSubmitBtn(this)
            }
        }, 100));

        $('._googleAuthenticatorSkipLink').click(function (e) {
            $('._googleAuthenticatorInput').closest('.inputWrapper').hide();
            login.validateForm(this);
            e.preventDefault();
        });


        $('._forgotPassword').click(function (e) {
            var loc = '/reset-password';
            document.location.href = loc;
            e.preventDefault();
        });

        $(document).on('click', '._togglePasswordVisibility', function (e) {
            e.preventDefault();
            var $toggleButton = $(this);
            var controlledInputId = $toggleButton.attr('aria-controls');
            var $controlledInput = controlledInputId ? $('#' + controlledInputId) : $();

            if (!$controlledInput.length) {
                $controlledInput = $toggleButton
                    .closest('.passwordFieldContainer')
                    .find('input')
                    .first();
            }

            if (!$controlledInput.length) {
                return;
            }

            var inputEl = $controlledInput.get(0);
            if (!inputEl) {
                return;
            }

            var shouldShowPassword = inputEl.type === 'password';
            inputEl.type = shouldShowPassword ? 'text' : 'password';
            $toggleButton.attr('aria-pressed', shouldShowPassword ? 'true' : 'false');
            $toggleButton
                .attr('aria-label', shouldShowPassword ? translation._('Hide password') : translation._('Show password'))
                .toggleClass('isVisible', shouldShowPassword);
            $toggleButton.find('.passwordVisibilityIcon').text(shouldShowPassword ? 'visibility' : 'visibility_off');
        });

        $('._showSSO').click(function (e) {
            e.preventDefault();
            login.showSsoSignIn();
        });

        $('._showSocialSignIn').click(function (e) {
            $('._notification').hide();
            $('._socialSignInBlock').show();
            $('._ssoBlock').hide();
            $('._mainLoginBlock').hide();
            $('._createAccountBlock').hide();
            login.resetLeftColumnScroll();

            $('input[autofocus="autofocus"]').focus();
            e.preventDefault();
        });

        $('._showCreateAccountForm, ._showLoginForm').click(function (e) {
            $('._notification').hide();
            $('._ssoBlock').hide();
            $('._socialSignInBlock').hide();
            $('input[autofocus="autofocus"]').focus();
            e.preventDefault();
        });
        $('._showCreateAccountForm').click(function (e) {
            $('._mainLoginBlock').hide();
            $('._createAccountBlock').show();
            $('input[autofocus="autofocus"]').focus();
            e.preventDefault();
        });
        $('._showLoginForm').click(function (e) {
            $('._mainLoginBlock').show();
            $('._createAccountBlock').hide();
            login.resetLeftColumnScroll();
            $loginEmailInput.trigger('focus');
            e.preventDefault();
        });

        // Facebook social login
        $('._socialLoginFacebook').click(function () {
            var pathname = document.location.pathname;
            var params = '?method=facebook';
            document.location.href = encodeURI(pathname.concat(params));
        });

        // Twitter social login
        $('._socialLoginTwitter').click(function () {
            var pathname = document.location.pathname;
            var params = '?method=twitter';
            document.location.href = encodeURI(pathname.concat(params));
        });

        // Google login
        $('._socialLoginGoogle').click(function () {
            var pathname = document.location.pathname;
            var params = '?method=google';
            document.location.href = encodeURI(pathname.concat(params));
        });

        // Apple social login
        $('._socialLoginApple').click(function () {
            var pathname = document.location.pathname;
            var params = '?method=apple';
            document.location.href = encodeURI(pathname.concat(params));
        });

        // LinkedIn social login
        $('._socialLoginLinkedin').click(function () {
            const pathname = document.location.pathname;
            const params = '?method=linkedin';
            document.location.href = encodeURI(pathname.concat(params));
        });

        // Verify account
        $('._socialVerify').click(function () {
            document.location.href = '/login?snid=' + $(this).data("snid");
        });

        $('._snProfileDropdown').click(function () {
            $('._moreSnProfiles').toggle();
            $('._snProfileDropdown').toggle();
        });

        // MFA Setup button click handler
        $('._setupMfa').on('click', function() {
            $('.enrolMFAStepOneContainer').hide();
            $('.standardLoginSwitch').hide();
            $('.header').hide();
            $('.mfaHeader').show();
            $('.enrolMFAStepTwoContainer').show();
            $('body').addClass('mfaFlow');
        });

        // Handle back to sign in link click
        $('.mfaLoginSwitch .link').on('click', function(e) {
            e.preventDefault();
            ajaxCall({
                url: '/ajax/auth/remove-ga-secret',
                type: 'post',
                success: function() {
                    // After successful removal, redirect to logout
                    window.location.href = '/logout?redirect=/login';
                },
                error: function() {
                    // Even if the AJAX call fails, still redirect to logout
                    window.location.href = '/logout?redirect=/login';
                }
            }, 'qm');
        });

        $('.backLink').on('click', function(e) {
            e.preventDefault();
            $('.mfaHeader').hide();
            $('.enrolMFAStepTwoContainer').hide();
            $('.enrolMFAStepOneContainer').show();
            $('.standardLoginSwitch').show();
            $('.header').show();
            $('body').removeClass('mfaFlow');

            // Hide elements that shouldn't be visible during MFA enrollment
            $('.superheroBackgroundImage').hide();
            $('.formContainer').hide();
        });

        // MFA code input handler
        $('input[name="mfaCode"]').on('input', function() {
            const $submitButton = $(this).closest('.enrolMFAStepTwoContainer').find('._submit');
            const $mfaCodeError = $(this).closest('.enrolMFAStepTwoContainer').find('.mfaCodeError');
            $submitButton.toggleClass('disabled', !$(this).val());
            $submitButton.attr('aria-disabled', !$(this).val());
            $mfaCodeError.hide();
        });

        // Initialize MFA submit button as disabled
        $('.enrolMFAStepTwoContainer ._submit').addClass('disabled').attr('aria-disabled', true);

        // Copy secret code to clipboard
        $('.icon-content-copy').on('click', function() {
            const secretCode = $('._gaSecret').text().trim();
            navigator.clipboard.writeText(secretCode).then(() => {
                $(this).addClass('copied');
                setTimeout(() => {
                    $(this).removeClass('copied');
                }, 2000);
            });
        });

        $('.submitCodeButton').on('click', function() {
            const $submitButton = $(this);
            const $mfaCodeInput = $submitButton.closest('.enrolMFAStepTwoContainer').find('input[name="mfaCode"]');
            const $mfaCodeError = $submitButton.closest('.enrolMFAStepTwoContainer').find('.mfaCodeError');
            const mfaCode = $mfaCodeInput.val();
            var url = '/ajax/auth/validate-ga-setup-code?code=' + mfaCode;
            ajaxCall({
                url: url,
                success: function(response) {
                    if (response.success) {
                        $mfaCodeError.hide();
                        window.location.href = `${hs.c.rootUrl}/signin?method=ga_get&code=${mfaCode}`;
                    } else {
                        $mfaCodeError.show();
                        $mfaCodeInput.val('');
                        $submitButton.addClass('disabled').attr('aria-disabled', true);
                    }
                },
                error: function() {
                    $mfaCodeError.show();
                    $mfaCodeInput.val('');
                    $submitButton.addClass('disabled').attr('aria-disabled', true);
                }
            }, 'qm');
        });

        $('._setupMfa, .learnMoreLink, .submitCodeButton').on('click', function() {
            let metricType

            if ($(this).hasClass('learnMoreLink')) {
                metricType = 'learnMore';
            } else if ($(this).hasClass('_setupMfa')) {
                metricType = 'startSetup';
            } else if ($(this).hasClass('submitCodeButton')) {
                metricType = 'submitSetup';
            }

            var url = `/ajax/metrics/record-mfa-metric?type=${metricType}`;
            ajaxCall({
                url: url
            }, 'qm');
        });

        hs.recaptcha.init(login);

        // Link account page
        var $linkAccountLogin = $('._linkAccount ._login'),
            $linkAccountCreate = $('._linkAccount ._create');
        $('._linkAccount ._connectNew').click(function (e) {
            e.preventDefault();
            e.stopPropagation();

            $linkAccountLogin.hide();
            $linkAccountCreate.show();
            login.toggleSubmitBtn($linkAccountCreate.find('form'));
        });

        $('._linkAccount ._signIn').click(function (e) {
            e.preventDefault();
            e.stopPropagation();

            $linkAccountCreate.hide();
            $linkAccountLogin.show();
            login.toggleSubmitBtn($linkAccountLogin.find('form'));
        });

        // Log the user out when facebook auth has failed so they can try a different FB account next time
        if (urlParams['method'] === 'facebook' && urlParams['code']) {
            login.logoutFacebookUser();
        }

        // delay is necessary as auto-filled fields are empty on document.ready
        _.delay(function () {
            if ($emailInput.val()) {
                // this trigger will handle the placeholder text and the google authenticator check
                $emailInput.trigger('change');
            }

            if ($passwordInput.val()) {
                $passwordInput.trigger('change');
            }

            var $emailFirstInput = $('._emailFirstForm ._emailInput');
            if ($emailFirstInput.length && $emailFirstInput.val()) {
                login.toggleContinueBtn($emailFirstInput.get(0));
            }
        }, 50);

        // Add the redirect query string to the action of the form
        login.addRedirectQueryParamInput(urlParams['redirect']);

        if (hs.isFeatureEnabled('WEL_1940_EMAIL_FIRST_SIGNIN')) {
            login.initEmailFirst();
        }

        login.focusErrorNotification();
    },
    /**
     * Reset the left column scroll position to the top.
     *
     * On desktop side-by-side the left column is the scroll region; when the user
     * switches between the main, SSO, and social sign-in views it should return to
     * the top so the new view starts at its logo/heading rather than mid-scroll.
     *
     * @returns {void}
     */
    resetLeftColumnScroll: function () {
        if (!hs.isFeatureEnabled('ID_5879_SIGNIN_FLOW_UPDATE')) {
            return;
        }

        var leftColumn = document.querySelector('.loginLeftColumn');
        if (leftColumn) {
            leftColumn.scrollTop = 0;
        }
    },
    transferLoginEmailToSso: function () {
        var $loginEmail = $('#loginEmailInput');
        var $ssoEmail = $('#ssoEmailInput');
        if (!$ssoEmail.length) {
            return;
        }

        $ssoEmail.val($loginEmail.val() || '');
        login.toggleSubmitBtn($ssoEmail.get(0));
    },
    /**
     * Focus on the error notification
     * This is to ensure screen readers announce the error message
     * 
     * @returns {void}
     */
    focusErrorNotification: function () {
        
        // Find a server-rendered error notification (from notifications.html)
        var $alert = $('._notification.notification.error[role="alert"]').first();
        if (!$alert.length) return;

        // Focus only the message block for SRs
        var $msgBox = $alert.find('.notificationMessage').first();
        if (!$msgBox.length) return;

        // Make the div script-focusable but not tabbable
        if (!$msgBox.attr('id')) $msgBox.attr('id', 'ssoNotificationMessage');
        $msgBox.attr('tabindex', '-1');
        
        var $title = $alert.find('.notificationTitle').first();
        if (!$title.length) return;

        // assign ids as we are not making changes to notifications.html
        if ($title && !$title.id) $title.id = 'ssoNotificationTitle';
        if (!$alert.id) $alert.id = 'ssoNotification';

        // link message to the input
        var $email = $('#ssoEmailInput');

        if ($email.length) {
  
            $email.attr('aria-invalid', 'true');
            $email.attr('aria-errormessage', ($msgBox && $msgBox.attr("id") || $alert.id));

            // manage aria-describedby
            var $describedBy = ($email.attr('aria-describedby') || '')
                .trim()
                .split(/\s+/)
                .filter(Boolean);

            var $ref = ($msgBox && $msgBox.attr("id")) || $alert.id;

            if ($ref && !$describedBy.includes($ref)) {
                $describedBy.push($ref);
                $email.attr('aria-describedby', $describedBy.join(' '));
            }
        }
    },


    /**
     * Wire up the email-first "Continue" flow (WEL_1940_EMAIL_FIRST_SIGNIN).
     *
     * The template renders this form with the password field hidden and a
     * Continue button in place of the Sign in button. Continue looks up the
     * account's authentication method and reveals the right next step, so the
     * user is not asked for a password before we know they have one.
     *
     * No-ops when the email-first markup is not present (WEL_1940_EMAIL_FIRST_SIGNIN off).
     *
     * @returns {void}
     */
    initEmailFirst: function () {
        var $form = $('._emailFirstForm');
        if (!$form.length) {
            return;
        }

        var $emailInput = $form.find('._emailInput');
        var $continueBtn = $form.find('._continueButton');

        $form.data('onEmailStep', true);
        $form.data('passwordlessStep', false);
        login.setEmailFirstPasswordRequired($form, false);
        login.setEmailFirstSsoVisible(false);

        login.toggleContinueBtn($emailInput.get(0));

        $emailInput.on('keyup blur input change', _.debounce(function () {
            login.toggleContinueBtn(this);
        }, 100));

        $form.on('submit', function (e) {
            if ($form.data('onEmailStep')) {
                e.preventDefault();
                login.handleContinue($form);
                return;
            }

            if ($form.data('passwordlessStep')) {
                e.preventDefault();
            }
        });

        $continueBtn.click(function (e) {
            e.preventDefault();
            login.handleContinue($form);
        });

        var $passwordlessBlock = login.getPasswordlessBlock($form);

        $passwordlessBlock.find('._resendMagicLink').click(function (e) {
            e.preventDefault();
            login.sendMagicLink($form, $form.data('passwordlessEmail'), true);
        });
    },

    /**
     * Enter on the shared email/password form: Continue while on the email-first step, else Sign in.
     *
     * @param {jQuery} $form
     * @returns {void}
     */
    handleEmailPasswordFormEnter: function ($form) {
        if ($form.data('onEmailStep')) {
            login.handleContinue($form);
            return;
        }

        if ($form.data('passwordlessStep')) {
            return;
        }

        var $submitBtn = $form.find('._submit');
        var canSubmit = login.validateForm($form) && $submitBtn.hasClass('green');
        if (!canSubmit) {
            return;
        }

        if (login.isIframe() && $form.children(['._submit']).hasClass('_ajaxCreateAccount')) {
            login.ajaxCreateAccount($form);
        } else {
            $form.submit();
        }
    },

    /**
     * The hidden password field keeps an empty `required` on the email step, which bars any
     * native submit of the form. Drop `required` rather than disabling the field: browsers
     * skip disabled inputs when autofilling, so password managers would leave the field empty
     * once the password step is revealed.
     *
     * @param {jQuery} $form
     * @param {boolean} isRequired
     * @returns {void}
     */
    setEmailFirstPasswordRequired: function ($form, isRequired) {
        $form.find('._passwordInput').prop('required', isRequired);
    },

    toggleContinueBtn: function (target) {
        if (!target) {
            return;
        }

        var $emailInput = $(target);
        var $form = $emailInput.closest('form');

        // While a lookup is pending the disabled state is the double-submit guard,
        // so editing the email must not green the button back up under it.
        if ($form.data('emailFirstLoading')) {
            return;
        }

        var $continueBtn = $form.find('._continueButton');
        var isValidEmail = '' !== $emailInput.val() && $emailInput.get(0).checkValidity();

        login.setContinueBtnEnabled($continueBtn, isValidEmail);
    },

    setContinueBtnEnabled: function ($continueBtn, enabled) {
        $continueBtn.toggleClass('disabled', !enabled);
        $continueBtn.toggleClass('green', enabled);
        $continueBtn.attr('aria-disabled', enabled ? 'false' : 'true');
        $continueBtn.attr('tabindex', enabled ? '0' : '-1');
    },

    /**
     * Resolve the account's authentication method for the entered email and
     * reveal the matching next step.
     *
     * `resolveAuthMethod` is stateless — it issues a request per call and does not
     * de-dupe — so guarding against double submits is this form's responsibility.
     * The loading flag it sets is that guard.
     *
     * @param {jQuery} $form
     * @returns {void}
     */
    handleContinue: function ($form) {
        if ($form.data('emailFirstLoading')) {
            return;
        }

        var $emailInput = $form.find('._emailInput');
        var email = $emailInput.val();
        if ('' === email || !$emailInput.get(0).checkValidity()) {
            return;
        }

        login.setEmailFirstLoading($form, true);

        login.getAuthMethodLookupRecaptchaToken()
            .then(function (recaptchaToken) {
                return resolveAuthMethod(email, recaptchaToken);
            })
            .then(function (result) {
                if (!login.isEmailFirstLookupCurrent($form, email)) {
                    return;
                }

                login.routeAuthOutcome(result.outcome, $form, email, result.hasSso);
            })
            .catch(function () {
                if (login.isEmailFirstLookupCurrent($form, email)) {
                    login.routeAuthOutcome(AUTH_OUTCOME.FALLBACK, $form, email);
                }
            })
            .finally(function () {
                login.setEmailFirstLoading($form, false);
                login.toggleContinueBtn($emailInput.get(0));
            });
    },

    /**
     * A settled lookup may only steer the page while the user is still on the email step
     * it was started from. SSO, social, and create-account controls stay clickable during
     * the request, so an outcome arriving after the user switched views would auto-submit
     * SSO over an email they were editing, or redirect them off the view they are on.
     *
     * @param {jQuery} $form
     * @param {string} email
     * @returns {boolean}
     */
    isEmailFirstLookupCurrent: function ($form, email) {
        var isEmailUnchanged = email === $form.find('._emailInput').val();
        var hasLeftEmailFirstView = $form.closest('._mainLoginBlock').is(':hidden');

        return isEmailUnchanged && !hasLeftEmailFirstView;
    },

    /**
     * Mint a reCAPTCHA v3 token for auth-method lookup when the page is not already
     * hosting a v2 widget. Google exposes a single `grecaptcha` global, so loading v3
     * after v2's `api.js?render=explicit` would break the checkbox — refuse instead and
     * let the lookup degrade to fallback.
     *
     * @returns {Promise<string|undefined>}
     */
    getAuthMethodLookupRecaptchaToken: function () {
        return login.getEmailFirstRecaptchaToken(RECAPTCHA_ACTION_AUTH_METHOD_LOOKUP);
    },

    getSendMagicLinkRecaptchaToken: function () {
        return login.getEmailFirstRecaptchaToken(RECAPTCHA_ACTION_SEND_MAGIC_LINK);
    },

    getEmailFirstRecaptchaToken: function (action) {
        if ($('#recaptchaWidget').length || $('#recaptchaWidgetV2').length) {
            return Promise.resolve(undefined);
        }

        return getToken(action).catch(function () {
            return undefined;
        });
    },

    /**
     * Clearing the loading state deliberately leaves the enabled state alone: the email may
     * have been edited to something invalid while the lookup ran, so only `toggleContinueBtn`
     * (called by the caller once the flag is down) can decide whether Continue is usable.
     *
     * @param {jQuery} $form
     * @param {boolean} isLoading
     * @returns {void}
     */
    setEmailFirstLoading: function ($form, isLoading) {
        $form.data('emailFirstLoading', isLoading);

        var $continueBtn = $form.find('._continueButton');
        $continueBtn.attr('aria-busy', isLoading ? 'true' : 'false');

        if (isLoading) {
            login.setContinueBtnEnabled($continueBtn, false);
            login.announceEmailFirst($form, translation._('Checking your account\u2026'));
        } else if ($form.data('onEmailStep')) {
            login.announceEmailFirst($form, '');
        }
    },

    routeAuthOutcome: function (outcome, $form, email, hasSso = false) {
        switch (outcome) {
            case AUTH_OUTCOME.SSO:
                login.startSsoFlow($form, email);
                break;
            case AUTH_OUTCOME.SIGNUP:
                login.goToPlans();
                break;
            case AUTH_OUTCOME.RECOVERY:
                login.routeRecoveryOutcome($form, email);
                break;
            case AUTH_OUTCOME.PASSWORD:
                login.revealPasswordStep($form, hasSso);
                break;
            case AUTH_OUTCOME.FALLBACK:
            default:
                login.revealPasswordStep($form, true);
                break;
        }
    },

    routeRecoveryOutcome: function ($form, email) {
        var $passwordlessBlock = login.getPasswordlessBlock($form);
        if (!$passwordlessBlock.length) {
            login.revealPasswordStep($form, true);
            return;
        }

        $form.data('onEmailStep', false);
        $form.data('passwordlessStep', true);
        $form.data('passwordlessEmail', email);
        $form.closest('.loginContainer').addClass('passwordlessView');

        $form.closest('._mainLoginBlock').hide();
        $passwordlessBlock.show();
        login.resetLeftColumnScroll();

        var $confirmation = $passwordlessBlock.find('._passwordlessConfirmation');
        login.sendMagicLink($form, email, false);
        $confirmation.get(0).focus();
    },

    getPasswordlessBlock: function ($form) {
        return $form.closest('.loginContainer').find('._passwordlessBlock');
    },

    sendMagicLink: function ($form, email, isResend) {
        var $passwordlessBlock = login.getPasswordlessBlock($form);

        if ($form.data('passwordlessSending')) {
            return;
        }
        if (isResend && $passwordlessBlock.find('._resendMagicLink').hasClass('disabled')) {
            return;
        }

        $form.data('passwordlessSending', true);
        login.setResendEnabled($form, false);
        login.announceEmailFirst($form, translation._('Sending your sign-in link\u2026'));

        var onSettled = function (response) {
            if (!login.isOnPasswordlessStep($form)) {
                return;
            }
            $form.data('passwordlessSending', false);
            if (response && 1 == response.success) {
                login.showPasswordlessSuccess($form, email);
            } else {
                login.showPasswordlessError($form, login.describeSendFailure(response));
            }
        };

        login.getSendMagicLinkRecaptchaToken().then(function (recaptchaToken) {
            if (!login.isOnPasswordlessStep($form)) {
                return;
            }

            if (!recaptchaToken) {
                $form.data('passwordlessSending', false);
                login.showPasswordlessError($form, {
                    message: translation._('We couldn\u2019t verify your browser, so we can\u2019t send a sign-in link.'),
                    canResend: false,
                });
                return;
            }

            var requestData = { email: email, recaptchaToken: recaptchaToken };
            var redirect = $form.find('input[name="redirect"]').val();
            if (redirect) {
                requestData.redirect = redirect;
            }

            ajaxRequest(SEND_MAGIC_LINK_URL, 'GET', {
                data: requestData,
            }).then(onSettled, onSettled);
        });
    },

    /**
     * A send settles asynchronously but writes to shared markup, so it may only touch the
     * passwordless UI while that step is still the one on screen.
     *
     * @param {jQuery} $form
     * @returns {boolean}
     */
    isOnPasswordlessStep: function ($form) {
        return true === $form.data('passwordlessStep');
    },

    /**
     * Some failures no retry can clear: a rate limit has to age out, and a browser that
     * cannot mint a reCAPTCHA token will not mint one on the next click either. Those must
     * leave Resend disabled, or the user is left pressing a button guaranteed to fail. The
     * create-password link inside the error block is the way out of every one of them.
     *
     * @param {Object|undefined} response
     * @returns {{message: string, canResend: boolean}}
     */
    describeSendFailure: function (response) {
        var errorCode = response ? Number(response.errorCode) : NaN;

        if (errorCode === MAGIC_LINK_IP_RATE_LIMITED) {
            return {
                message: translation._('We\u2019ve sent too many sign-in links from this network. Please try again later.'),
                canResend: false,
            };
        }

        if (errorCode === MAGIC_LINK_EMAIL_RATE_LIMITED) {
            return {
                message: translation._('We\u2019ve sent too many sign-in links to this email. Please try again later.'),
                canResend: false,
            };
        }

        return {
            message: translation._('We couldn\u2019t send your sign-in link. Please try again.'),
            canResend: true,
        };
    },

    showPasswordlessSuccess: function ($form, email) {
        var $passwordlessBlock = login.getPasswordlessBlock($form);

        login.clearPasswordlessError($form);
        $passwordlessBlock.find('._passwordlessEmail').text(email);
        $passwordlessBlock.find('._passwordlessSuccess').show();

        login.startResendCooldown($form);
        login.announceEmailFirst(
            $form,
            translation._('We sent a sign-in link to your email. Open it on this device to sign in.')
        );
    },

    /**
     * `._passwordlessError` carries role="alert" and already contains the create-password
     * link, so announcing through `._emailFirstStatus` too would read the failure twice.
     *
     * @param {jQuery} $form
     * @param {{message: string, canResend: boolean}} failure
     * @returns {void}
     */
    showPasswordlessError: function ($form, failure) {
        var $passwordlessBlock = login.getPasswordlessBlock($form);

        $passwordlessBlock.find('._passwordlessSuccess').hide();
        $passwordlessBlock.find('._passwordlessErrorMessage').text(failure.message);
        $passwordlessBlock.find('._passwordlessError').show();

        login.clearResendCooldown($form);
        $passwordlessBlock.find('._resendCountdown').text('');
        login.setResendEnabled($form, failure.canResend);
        login.announceEmailFirst($form, '');
    },

    clearPasswordlessError: function ($form) {
        var $passwordlessBlock = login.getPasswordlessBlock($form);

        $passwordlessBlock.find('._passwordlessError').hide();
        $passwordlessBlock.find('._passwordlessErrorMessage').text('');
    },

    startResendCooldown: function ($form) {
        login.clearResendCooldown($form);

        var remaining = PASSWORDLESS_RESEND_COOLDOWN_SECONDS;
        login.setResendEnabled($form, false);
        login.renderResendCountdown($form, remaining);

        var intervalId = setInterval(function () {
            remaining -= 1;
            if (remaining <= 0) {
                login.clearResendCooldown($form);
                login.getPasswordlessBlock($form).find('._resendCountdown').text('');
                login.setResendEnabled($form, true);
                login.announceEmailFirst($form, translation._('You can resend the sign-in link now.'));
            } else {
                login.renderResendCountdown($form, remaining);
            }
        }, 1000);

        $form.data('resendCooldownInterval', intervalId);
    },

    /**
     * Rewrites the countdown every second, so `._resendCountdown` must not be an aria-live
     * region — it would announce ~60 times per send. The Resend button points at it with
     * aria-describedby, and cooldown start/end are announced once through `._emailFirstStatus`.
     *
     * @param {jQuery} $form
     * @param {number} remaining
     * @returns {void}
     */
    renderResendCountdown: function ($form, remaining) {
        var template = translation._('Resend available in %d seconds');
        login.getPasswordlessBlock($form).find('._resendCountdown').text(template.replace('%d', remaining));
    },

    clearResendCooldown: function ($form) {
        var intervalId = $form.data('resendCooldownInterval');
        if (intervalId) {
            clearInterval(intervalId);
            $form.data('resendCooldownInterval', null);
        }
    },

    /**
     * Resend keeps its place in the tab order while disabled. It is `aria-disabled` rather
     * than natively disabled, so taking away its tabindex — as `setContinueBtnEnabled` does
     * — would hide both the button and the countdown it points at from keyboard users for
     * the whole cooldown. `sendMagicLink` is what refuses a click on a disabled resend.
     *
     * @param {jQuery} $form
     * @param {boolean} enabled
     * @returns {void}
     */
    setResendEnabled: function ($form, enabled) {
        var $resend = login.getPasswordlessBlock($form).find('._resendMagicLink');

        $resend.toggleClass('disabled', !enabled);
        $resend.attr('aria-disabled', enabled ? 'false' : 'true');
    },

    startSsoFlow: function ($form, email) {
        var $ssoForm = $('._emailSsoForm');
        var ssoFormEl = $ssoForm.get(0);

        if (!ssoFormEl) {
            login.revealPasswordStep($form, true);
            return;
        }

        // Reuse the server-rendered SSO form so its action (sign-in source) and
        // the redirect hidden input added in addRedirectQueryParamInput are kept.
        $ssoForm.find('._emailInput').val(email);
        ssoFormEl.submit();
    },

    showSsoSignIn: function () {
        if (login.startSsoFlowWithEnteredEmail()) {
            return;
        }

        $('._notification').hide();
        $('._ssoBlock').show();
        $('._socialSignInBlock').hide();
        $('._mainLoginBlock').hide();
        $('._createAccountBlock').hide();
        login.resetLeftColumnScroll();
        login.transferLoginEmailToSso();
        $('#ssoEmailInput').trigger('focus');
    },

    startSsoFlowWithEnteredEmail: function () {
        var $form = $('._emailFirstForm');
        if (!$form.length || !$('._emailSsoForm').length) {
            return false;
        }

        var $emailInput = $form.find('._emailInput');
        var email = $emailInput.val();
        if ('' === email || !$emailInput.get(0).checkValidity()) {
            return false;
        }

        login.startSsoFlow($form, email);

        return true;
    },

    goToPlans: function () {
        util.doRedirect('plans');
    },

    revealPasswordStep: function ($form, hasSso = false) {
        login.revealStandardForm($form);
        login.setEmailFirstSsoVisible(hasSso);
    },

    revealStandardForm: function ($form) {
        $form.data('onEmailStep', false);
        $form.data('passwordlessStep', false);
        login.setEmailFirstPasswordRequired($form, true);
        $form.find('._passwordFieldWrapper').show();
        $form.find('._continueButton').hide();
        $form.find('._submit').show();

        login.toggleSubmitBtn($form);

        login.announceEmailFirst($form, translation._('Enter your password to sign in.'));
        $form.find('._passwordInput').focus();
    },

    setEmailFirstSsoVisible: function (isVisible) {
        var $ssoBtn = $('._showSSO');
        if (isVisible) {
            $ssoBtn.show();
        } else {
            $ssoBtn.hide();
        }
    },

    announceEmailFirst: function ($form, message) {
        if ($form.data('passwordlessStep')) {
            login.getPasswordlessBlock($form).find('._emailFirstStatus').text(message);
            return;
        }

        $form.find('._emailFirstStatus').text(message);
    },

    logoutFacebookUser: function () {
        //updated sdk url and passing in version number
        return asyncLoader('https://connect.facebook.net/en_US/sdk.js').then(function () {
            var initData = {
                appId: hs.fbAppId,
                status: true,
                cookie: true,
                xfbml: false
            };
            var version = hs.fbApiVersion;
            if (version) {
                initData.version = 'v' + version;
            }

            window.FB.init(initData);

            window.FB.getLoginStatus(function (response) {
                if (response.status && response.status === 'connected') {
                    window.FB.logout();
                }
            }, true);
        });
    },

    validateRequiredFields: function (target) {
        var $form = $(target).closest('form');
        var allRequiredFieldsValid = true;

        var $requiredFields = $form.find('._requiredInput');

        _.each($requiredFields, function (input) {
            var $input = $(input);

            if ($input.is(':visible') && "" === $input.val()) {
                allRequiredFieldsValid = false;
            }
        });

        return allRequiredFieldsValid;
    },

    validateEmailField: function (target, ignoreCreateErrorBubble) {
        var $form = $(target).closest('form');
        var $input = $form.find('._emailInput');
        var $inlineErrorContainer = $input.siblings('._inlineErrorContainer');
        // When present (reset password signin flow update), surface the invalid email
        // error as a top banner consistent with the success banner. Otherwise fall back
        // to the inline error bubble.
        var $topErrorBanner = $('._clientErrorBanner');

        if (!$input.length || ($input.is(':hidden') && $form.is(':visible'))) {
            return true;
        }

        if (!$input[0].checkValidity()) {
            // show error
            if (!ignoreCreateErrorBubble) {
                // Hide any server-rendered success notification so the user never
                // sees conflicting success + error messaging at once (applies to
                // both the top banner and the inline error paths).
                $('._notification.success').css("display", "none");
                if ($topErrorBanner.length) {
                    $topErrorBanner.find('._clientErrorTitle').text(translation._("Invalid email"));
                    $topErrorBanner.find('._clientErrorBody').text(translation._("Please enter a valid email address"));
                    $topErrorBanner.css("display", "flex");
                    // Tie the banner text to the input so assistive tech announces
                    // the error (the banner lives outside the field's DOM context).
                    $input.attr('aria-describedby', 'clientErrorTitle clientErrorBody');
                } else if ($inlineErrorContainer.length) {
                    $inlineErrorContainer.css("display", "flex");
                    $inlineErrorContainer.find('._inlineErrorTitle').text(translation._("Invalid email"));
                    $inlineErrorContainer.find('._inlineErrorMessage').text(translation._("Please enter a valid email address"));
                    $input.attr('aria-describedby', `inlineErrorTitle inlineErrorMessage`)
                }
                $input.attr('aria-invalid', 'true');
            }
            return false;
        } else {
            // remove errors
            $inlineErrorContainer.css("display", "none");
            if ($topErrorBanner.length) {
                $topErrorBanner.css("display", "none");
            }
            // Restore the server success notification we may have hidden while the
            // email was invalid, so the post-submit "check your email" confirmation
            // isn't lost after the user fixes a typo. Clearing the inline display
            // reverts to the stylesheet default (no-op when no success banner exists).
            $('._notification.success').css("display", "");
            $input.attr('aria-invalid', 'false');
            // Only drop the invalid-email associations we added, preserving any
            // server-error association (e.g. ssoNotificationMessage) set elsewhere.
            var ownErrorIds = ['clientErrorTitle', 'clientErrorBody', 'inlineErrorTitle', 'inlineErrorMessage'];
            var remainingDescribedBy = ($input.attr('aria-describedby') || '')
                .split(/\s+/)
                .filter(function (id) { return id && ownErrorIds.indexOf(id) === -1; });
            if (remainingDescribedBy.length) {
                $input.attr('aria-describedby', remainingDescribedBy.join(' '));
            } else {
                $input.removeAttr('aria-describedby');
            }
            return true;
        }
    },

    validateResetPassword: function(target, ignoreCreateErrorBubble, inputName, passwordConfirmationName) {
        var $form = $(target).closest('form');
        var $input = $form.find(inputName);
        var $confirmation = $form.find((passwordConfirmationName))
        var $inlineErrorContainer = $input.siblings('._inlineErrorContainer');

        if (!$input.length || ($input.is(':hidden') && $form.is(':visible'))) {
            return true;
        }

        var validationResult = hs.util.isResetPasswordValid($input.val()) && hs.util.checkNewPasswordPolicy($input, $confirmation)

        if (!validationResult) {
            // show inline error
            if (!ignoreCreateErrorBubble && $inlineErrorContainer.length) {
                $inlineErrorContainer.css("display", "flex");
                $inlineErrorContainer.find('._inlineErrorTitle').text(translation._("Invalid password"));
                $inlineErrorContainer.find('._inlineErrorMessage').text(translation._("Your password does not meet our password policy"));
            }
            return false;
        } else {
            // remove inline error
            $inlineErrorContainer.css("display", "none");
            return true;
        }
    },

    validatePassword: function(target, ignoreCreateErrorBubble, inputName) {
        var $form = $(target).closest('form');
        var $input = $form.find(inputName);
        var $inlineErrorContainer = $input.siblings('._inlineErrorContainer');

        if (!$input.length || ($input.is(':hidden') && $form.is(':visible'))) {
            return true;
        }

        if (!hs.util.isPasswordValid($input.val())) {
            // show inline error
            if (!ignoreCreateErrorBubble && $inlineErrorContainer.length) {
                $inlineErrorContainer.css("display", "flex");
                $inlineErrorContainer.find('._inlineErrorTitle').text(translation._("Invalid password"));
                $inlineErrorContainer.find('._inlineErrorMessage').text(translation._("Your password is too short"));
            }
            return false;
        } else {
            // remove inline error
            $inlineErrorContainer.css("display", "none");
            return true;
        }
    },

    validatePasswordField: function (target, ignoreCreateErrorBubble) {
        var inputName = '._passwordInput';
        return login.validatePassword(target, ignoreCreateErrorBubble, inputName);
    },

    validatePasswordNewField: function (target, ignoreCreateErrorBubble) {
        var inputName = '._passwordInputNew';
        return login.validatePassword(target, ignoreCreateErrorBubble, inputName);
    },

    validateGoogleAuthenticatorField: function (target) {
        var $form = $(target).closest('form');
        var $input = $form.find('._googleAuthenticatorInput');
        var $inlineErrorContainer = $input.siblings('._inlineErrorContainer');

        if (!$input.length || ($input.is(':hidden') && $form.is(':visible'))) {
            return true;
        }

        if (!hs.util.isGoogleAuthenticatorValid($input.val())) {
            // show inline error
            if ($inlineErrorContainer.length) {
                $inlineErrorContainer.css("display", "flex");
                $inlineErrorContainer.find('._inlineErrorTitle').text(translation._("Invalid code"));
                $inlineErrorContainer.find('._inlineErrorMessage').text(translation._("Please enter a valid Google Authenticator code"));
                document.getElementById('verifyGoogleAuthenticatorInput').setAttribute("aria-invalid", "true");
            }
            return false;
        } else {
            // remove inline error
            $inlineErrorContainer.css("display", "none");
            document.getElementById('verifyGoogleAuthenticatorInput').setAttribute("aria-invalid", "false");
            return true;
        }
    },

    validateForm: function (target) {
        login.toggleSubmitBtn(target);

        var isValidForm = '';
        if ($('._passwordInputNew').length) {
            isValidForm =
                login.validateRequiredFields(target) &&
                login.validateEmailField(target) &&
                login.validatePasswordField(target) &&
                login.validatePasswordNewField(target) &&
                login.validateGoogleAuthenticatorField(target);
        } else {
            isValidForm =
                login.validateRequiredFields(target) &&
                login.validateEmailField(target) &&
                login.validatePasswordField(target) &&
                login.validateGoogleAuthenticatorField(target);
        }

        return isValidForm;
    },

    toggleSubmitBtn: function (target) {
        login.validatePasswordField(target, true);

        // In order to enable the submit button we only strictly care that the
        // email field is valid and that required fields are not empty.
        var enableSubmitBtn =
            login.validateRequiredFields(target) &&
            login.validateEmailField(target, true);

        login.setSubmitBtnEnabled(enableSubmitBtn, target);
    },

    toggleSubmitResetPasswordButton: function(target) {
        var inputName = '#newPasswordInput'
        var confirmationName = '#newPasswordInputConfirmation'
        var validateResetPassword = login.validateResetPassword(target, false, inputName, confirmationName);
        login.setSubmitBtnEnabled(validateResetPassword, target);
    },

    isEmailPasswordAutoFilled: function () {
        return $("#loginEmailInput").css('appearance') === 'menulist-button' && $("#loginPasswordInput").css('appearance') === 'menulist-button';
    },
    detectChromeAutofill: true,
    setSubmitBtnEnabled: function (enabled, target) {
        var $form = $(target).closest('form');
        var setAttributesAndClasses = function (enabled) {
            var $submitBtn = $form.find('._submit');

            // toggle aria-disabled on submit button
            if (!enabled) {
                $submitBtn.attr("aria-disabled", true);
                $submitBtn.attr("tabindex", '-1')
                $submitBtn.attr("aria-describedby", "inlineErrorContainer")
            } else {
                $submitBtn.attr("tabindex", '0')
                $submitBtn.attr("aria-disabled", false);
                $submitBtn.removeAttr("aria-describedby")
            }

            $submitBtn.toggleClass('disabled', !enabled);
            $submitBtn.toggleClass('green', enabled);
        }

        if (login.isChrome() && $form.is('._emailPasswordForm')) {
            setAttributesAndClasses(enabled)

            if (login.detectChromeAutofill) {
                login.detectChromeAutofill = false

                var intervalId;
                var triesRemaining = 10;

                intervalId = setInterval(function () {
                    if (login.isEmailPasswordAutoFilled()) {
                        setAttributesAndClasses(true)
                        clearInterval(intervalId)
                    }

                    triesRemaining--;

                    if (triesRemaining === 0) {
                        clearInterval(intervalId)
                    }
                }, 200)
            }

        } else {
            setAttributesAndClasses(enabled)
        }

    },

    isChrome: function () {
        var agent = navigator.userAgent.toLowerCase();
        return (agent.search("chrome") > -1 && agent.search("safari") > -1);
    },

    isIframe: function () {
        if (typeof window.top === 'object' && typeof window.self === 'object') {
            return (window.top.location !== window.self.location);
        }
        return false;
    },

    ajaxCreateAccount: function (element) {
        var notification = $('._ajax-notification');
        var errorNotification = function (message) {
            notification.show();
            notification.removeClass('success');
            notification.addClass('error');
            notification.html(message);
        };
        var successNotification = function (message) {
            notification.show();
            notification.removeClass('error');
            notification.addClass('success');
            notification.html(message);
        };
        var postData = element.closest('form').serialize();
        ajaxCall({
            type: 'POST',
            url: "/ajax/member/ajax-new-signup",
            data: postData,
            success: function (data) {
                if (data.success == '1') {
                    successNotification("Success!");
                    top.location = hs.util.getUrlRoot() + "/account-setup";
                }
                else
                {
                    // Update the token for new session
                    $("._signupForm input[name='token']").val(data.token);
                    // Just show the form errors
                    if (data.error) {
                        // Redirect spammers
                        if (data.errorCode == 403) {
                            util.doRedirect('/security/unusual-activity');
                        }
                        errorNotification(data.error);
                    }
                }
            },
            error: function () {
                errorNotification("Could not complete sign up, please try again.");
            }
        }, 'qmNoAbort');
    },

    // Add the redirect query string hidden input to the email form
    // This is necessary since Hootsuite uses hashs (#) as important navigation URLs
    // However, hashs are NOT send to the backend by the browser, so we are forcing it in the query
    addRedirectQueryParamInput: function(redirectValue) {
        if (!redirectValue) return;

        let redirectURL = redirectValue;
        if (window.location.hash) {
            redirectURL = redirectURL + window.location.hash;
        }

        const redirectInput = document.createElement('input');
        redirectInput.setAttribute("type", "hidden");
        redirectInput.setAttribute("name", "redirect");
        redirectInput.setAttribute("value", redirectURL);

        const emailForm = document.querySelector('._emailPasswordForm')
        emailForm.appendChild(redirectInput.cloneNode(true));

        const ssoForm = document.querySelector('._emailSsoForm')
        ssoForm.appendChild(redirectInput.cloneNode(true));
    }
};

export default login;

